import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const UPDATE_BUSINESS_SETTINGS_REQUEST = 'UPDATE_BUSINESS_SETTINGS_REQUEST'
export const UPDATE_BUSINESS_SETTINGS_SUCCESS = 'UPDATE_BUSINESS_SETTINGS_SUCCESS'
export const UPDATE_BUSINESS_SETTINGS_FAILURE = 'UPDATE_BUSINESS_SETTINGS_FAILURE'

export const updateBusinessSettings = (id, configId, body) => ({
  [CALL_API]: {
    endpoint: '/api/business/businesses/' + id + '/config/' + configId + '/',
    types: [UPDATE_BUSINESS_SETTINGS_REQUEST, UPDATE_BUSINESS_SETTINGS_SUCCESS, UPDATE_BUSINESS_SETTINGS_FAILURE],
    method: 'PATCH',
    tokenType: API_JWT_TOKEN_NAME,
    body,
  },
})
